import AnalyticsLoadingState from "@/components/RequestsAnalytics/AnalyticsLoadingState";

interface AgGridLoadingOverlayProps {
  headerHeight: number;
  footerHeight: number;
  label: string;
  description: string;
}

export const AgGridLoadingOverlay = ({
  headerHeight,
  footerHeight,
  label,
  description,
}: AgGridLoadingOverlayProps) => (
  <div
    className="pointer-events-none absolute inset-x-[1px] z-10 my-[1px] flex items-center justify-center bg-white/95"
    style={{
      top: headerHeight,
      bottom: footerHeight,
    }}
    aria-busy="true"
    aria-live="polite"
  >
    <AnalyticsLoadingState label={label} description={description} />
  </div>
);
